import { createSlice } from '@reduxjs/toolkit';

import { createReminder } from 'Feature/BasicInfo/Reminder/CreateReminder/Actions/action';

import ICreateReminderState from './model';

const initialState: ICreateReminderState = {
  createReminderState: {
    loading: false,
    isSuccess: false,
  },
};

export const createRemindersSlice = createSlice({
  name: 'reminder/CreateReminder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createReminder.pending, (state) => {
        state.createReminderState.loading = true;
      })
      .addCase(createReminder.fulfilled, (state, action) => {
        state.createReminderState.loading = false;
        if (action.payload && action.payload.status === 200) {
          state.createReminderState.isSuccess = true;
        }
      })
      .addCase(createReminder.rejected, (state) => {
        state.createReminderState.loading = false;
      });
  },
});

export default createRemindersSlice.reducer;
